"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationModal = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var ConfirmDialog_1 = require("components/modals/ConfirmDialog");
var modalEnhance = (0, recompose_1.compose)((0, recompose_1.withState)('items', 'setItems', []), (0, recompose_1.lifecycle)({
    componentDidUpdate: function (prevProps) {
        if (this.props.isOpen !== prevProps.isOpen ||
            this.props.errors !== prevProps.errors) {
            var errorList = this.props.errors.fold([], function (errors) {
                return Object.entries(errors).reduce(function (acc, _a) {
                    var key = _a[0], value = _a[1];
                    return value.reduce(function (r, i) {
                        if (key === 'email') {
                            r.push(i);
                        }
                        else {
                            r.push("".concat((0, translation_1.getLocalization)("bid/messageView/".concat(key)), ": ").concat(i));
                        }
                        return r;
                    }, acc);
                }, []);
            });
            this.props.setItems(errorList);
        }
    },
    shouldComponentUpdate: function (nextProps) {
        if (this.props.isOpen || nextProps.isOpen) {
            return true;
        }
        else {
            return false;
        }
    }
}), recompose_1.pure);
exports.ValidationModal = modalEnhance(function (props) { return (React.createElement(ConfirmDialog_1.ConfirmDialog, { overlayClassName: 'generic-warning-confirmation-modal', isOpen: props.isOpen, close: props.close, header: (0, translation_1.getLocalization)('bid/message/modal/header/warning'), body: React.createElement(React.Fragment, null,
        React.createElement(ConfirmDialog_1.Exclamation, null),
        React.createElement("div", null,
            React.createElement("div", { className: 'title please-confirm-text' },
                React.createElement("h2", { className: 'title' }, (0, translation_1.getLocalization)('bid/message/modal/header3/warning'))),
            React.createElement("div", { className: 'text' },
                React.createElement("p", null, (0, translation_1.getLocalization)('bid/message/modal/validationErrors')),
                props.items && props.items.map(function (e) { return React.createElement("div", null, e); })))), footer: React.createElement(sok_ui_1.Button, { color: 'dark-gray', text: (0, translation_1.getLocalization)('buttons/close'), onClick: props.close }) })); });
